import { render, staticRenderFns } from "./DrugInventoryAdjustList.vue?vue&type=template&id=6d2af588&scoped=true&"
import script from "./DrugInventoryAdjustList.vue?vue&type=script&lang=js&"
export * from "./DrugInventoryAdjustList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2af588",
  null
  
)

export default component.exports